import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { WebApiService } from 'src/app/shared/services/web-api.service';

@Injectable({
  providedIn: 'root'
})
export class SupportTicketSystemService {
  constructor(private webApiService: WebApiService) {}

  createBuyerTicket(payload: any): Promise<any> {
    const apiUrl = `/supportTicketSystem/createBuyerTicket`;
    return this.webApiService.postRequest<any>(apiUrl, payload);
  }

  listBuyerTickets(params: { buyerId?: number; limit?: number; offset?: number; status?: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/getBuyerTicketsLists`;
    let httpParams = new HttpParams();
    if (params?.buyerId) httpParams = httpParams.set('buyerId', String(params.buyerId));
    if (params?.limit) httpParams = httpParams.set('limit', String(params.limit));
    if (params?.offset) httpParams = httpParams.set('offset', String(params.offset));
    if (params?.status) httpParams = httpParams.set('status', params.status);
    return this.webApiService.getRequest1<any>(apiUrl, httpParams);
  }

  getBuyerTicketDetails(id: number, ticketRefNumber?: string): Promise<any> {
    const apiUrl = `/supportTicketSystem/buyer/tickets/${id}`;
    let httpParams = new HttpParams();
    if (ticketRefNumber) httpParams = httpParams.set('ticketRefNumber', ticketRefNumber);
    return this.webApiService.getRequest<any>(apiUrl, httpParams);
  }

  updateTicketStatusByBuyer(payload: { ticketId: string; status: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/updateTicketStatusByBuyer`;
    return this.webApiService.postRequest<any>(apiUrl, payload);
  }

  updateTicketStatusBySupplier(payload: { ticketId: string; status: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/updateTicketStatusBySupplier`;
    return this.webApiService.postRequest<any>(apiUrl, payload);
  }

  createSupplierTicket(payload: any): Promise<any> {
    const apiUrl = `/supportTicketSystem/createSupplierTicket`;
    return this.webApiService.postRequest<any>(apiUrl, payload);
  }

  listSupplierTickets(params: { supplierId?: number; limit?: number; offset?: number; status?: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/getSupplierTicketsLists`;
    let httpParams = new HttpParams();
    if (params?.supplierId) httpParams = httpParams.set('supplierId', String(params.supplierId));
    if (params?.limit) httpParams = httpParams.set('limit', String(params.limit));
    if (params?.offset) httpParams = httpParams.set('offset', String(params.offset));
    if (params?.status) httpParams = httpParams.set('status', params.status);
    return this.webApiService.getRequest1<any>(apiUrl, httpParams);
  }

  listAdminTickets(params: { limit?: number; offset?: number; status?: string; searchTerm?: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/getAllTicketsForAdmin`;
    let httpParams = new HttpParams();
    if (params?.limit) httpParams = httpParams.set('limit', String(params.limit));
    if (params?.offset) httpParams = httpParams.set('offset', String(params.offset));
    if (params?.status) httpParams = httpParams.set('status', params.status);
    if (params?.searchTerm) httpParams = httpParams.set('searchTerm', params.searchTerm);
    return this.webApiService.getRequest1<any>(apiUrl, httpParams);
  }

  updateTicketStatusByAdmin(payload: { ticketId: number; ticketSource: string; status: string }): Promise<any> {
    const apiUrl = `/supportTicketSystem/updateTicketStatusByAdmin`;
    return this.webApiService.postRequest<any>(apiUrl, payload);
  }

  getSupplierTicketDetails(id: number, ticketRefNumber?: string): Promise<any> {
    const apiUrl = `/supportTicketSystem/supplier/tickets/${id}`;
    let httpParams = new HttpParams();
    if (ticketRefNumber) httpParams = httpParams.set('ticketRefNumber', ticketRefNumber);
    return this.webApiService.getRequest<any>(apiUrl, httpParams);
  }
}
